// extracted by mini-css-extract-plugin
export default {"container":"style_container__GDnuw","archiveBtn":"style_archiveBtn__+Otun","formItem":"style_formItem__m+Mcx","label":"style_label__iwTTM"};